import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';

const CookieConsent = () => {
  const navigate = useNavigate();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const consent = localStorage.getItem('revocut_cookie_consent');
    if (!consent) {
      // Small delay for better UX
      setTimeout(() => setShowBanner(true), 1000);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('revocut_cookie_consent', 'accepted');
    localStorage.setItem('revocut_cookie_consent_date', new Date().toISOString());
    setShowBanner(false);
  };

  const declineCookies = () => {
    localStorage.setItem('revocut_cookie_consent', 'declined');
    localStorage.setItem('revocut_cookie_consent_date', new Date().toISOString());
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-[9999] p-4 md:p-6"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.95)', backdropFilter: 'blur(20px)' }}
    >
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6">
          {/* Icon */}
          <div 
            className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: 'rgba(92, 99, 255, 0.15)' }}
          >
            <Cookie className="w-6 h-6" style={{ color: '#5C63FF' }} />
          </div>

          {/* Text */}
          <div className="flex-1">
            <h3 className="text-white font-semibold mb-1">Wir verwenden Cookies</h3>
            <p className="text-gray-400 text-sm">
              Diese Website verwendet Cookies, um Ihnen die bestmögliche Erfahrung zu bieten. 
              Durch die weitere Nutzung der Website stimmen Sie der Verwendung von Cookies zu.{' '}
              <button 
                onClick={() => navigate('/cookies')}
                className="text-purple-400 hover:text-purple-300 underline"
              >
                Mehr erfahren
              </button>
            </p>
          </div>

          {/* Buttons */}
          <div className="flex items-center gap-3 w-full md:w-auto">
            <button
              onClick={declineCookies}
              className="flex-1 md:flex-none px-5 py-2.5 rounded-xl text-sm font-medium text-gray-400 hover:text-white border border-white/10 hover:border-white/20 transition-all"
            >
              Ablehnen
            </button>
            <button
              onClick={acceptCookies}
              className="flex-1 md:flex-none px-6 py-2.5 rounded-xl text-sm font-semibold text-white transition-all hover:scale-105"
              style={{ backgroundColor: '#5C63FF' }}
            >
              Akzeptieren
            </button>
          </div>

          {/* Close button (mobile) */}
          <button
            onClick={declineCookies}
            className="absolute top-4 right-4 md:hidden p-2 text-gray-500 hover:text-white"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
